import { Injectable } from '@angular/core';
import { MapifyMap } from '../models/MapifyMap';

@Injectable()
export class UtilsService {
  constructor() {}

  toProperCase(str: string): string {
    return str.replace(/\w\S*/g, txt => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
  }

  isRomanticEnabled(map: MapifyMap) {
    return (
      Object.keys(map.texts).length > 0 &&
      map.texts.title !== undefined &&
      map.texts.title.font.family.getValue() === 'Romantic'
    );
  }
}



// WEBPACK FOOTER //
// /vercel/workpath0/src/app/services/utils.service.ts